module.exports = __webpack_public_path__ + "img/person-icon.5b9eaa64.png";